export default "__VITE_ASSET__BNojVd1A__"